import getStore from '../store/store';
import { createDisplayDate } from 'owa-datetime';
import { mutator } from 'satcheljs';
import setEndDate from '../../actions/setEndDate';
import { getEndDate, getStartDate } from '../../selectors/getStoreProperties';
import getEndDateAfterModifications from '../../utils/getEndDateAfterModifications';
/**
 * Function to mutate the end date.
 */
export default mutator(setEndDate, function (actionMessage) {
    var date = actionMessage.date;
    var optionState = getStore().currentState;
    var curEnd = getEndDate();
    var endHours = curEnd.getHours();
    var endMinutes = curEnd.getMinutes();
    // Get the new end date values
    var newEndYear = date.getFullYear();
    var newEndMonth = date.getMonth();
    var newEndDate = date.getDate();
    // Set new end
    var newEnd = createDisplayDate(newEndYear, newEndMonth, newEndDate, endHours, endMinutes);
    optionState.endDate = newEnd;
    var startDate = getStartDate();
    optionState.startDate = createDisplayDate(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), startDate.getHours(), startDate.getMinutes());
    optionState.endDate = getEndDateAfterModifications();
});
//# sourceMappingURL=setEndDate.js.map